module.exports = __webpack_public_path__ + "img/upload-2.e38cf136.svg";